import React from 'react';

export function OverviewItem({icon, heading, text}) {
    return (
        <div className="overview__item">
            <span className={`overview__item__icon overview__item__icon--${icon}`} />
            <div className="">
                <h4>{heading}</h4>
                <p>{text}</p>
            </div>
        </div>
    );
}

export default OverviewItem;
